<template>
    <section id="section">
        <div class="dancer-info-box cb">
            <div class="dancer-avatar-box" :style="`background-image: url('${thumb}')`">
                <!--<img class="dancer-avatar" v-lazy="thumb">-->
            </div>
            <div class="dancer-nico-box fl">
                <div class="dancer-nico">{{name}}</div>
                <div class="dancer-resume ellipsis">{{digest}}</div>
            </div>

            <div class="dancer-follow bg fr" @click="follow" v-show="!is_follow">关注</div>
            <div class="dancer-follow unfollow fr" @click="unfollow" v-show="is_follow">取消关注</div>

            <ul class="dancer-counts-box">
                <li class="dancer-counts">
                    <div class="dancer-counts-item fl">
                        <p class="dancer-counts-number">{{counts}}</p>
                        <p class="dancer-counts-describe">视频</p>
                    </div>
                    <i class="right-line fl"></i>
                </li>
                <li class="dancer-counts">
                    <div class="dancer-counts-item fl">
                        <p class="dancer-counts-number">{{views > 9999 ? `${Math.round(views  / 1000) / 10}万` : views}}</p>
                        <p class="dancer-counts-describe">播放</p>
                    </div>
                    <i class="right-line fl"></i>
                </li>
                <li class="dancer-counts">
                    <div class="dancer-counts-item fl">
                        <p class="dancer-counts-number">{{fans}}</p>
                        <p class="dancer-counts-describe">关注</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="tab-box">
            <div class="tab-box-main df">
                <div  v-waves>
                    <router-link :to="`/dancers/${id}`" :class="`tab${tab === 'dancerVideo' ? ' active' : ''}`">视频</router-link>
                </div>

                <!--@click="$router.push(`/dancer/${id}/activity`)"-->
                <div v-waves>
                    <router-link :to="`/dancers/${id}/activities`" :class="`tab${tab === 'dancerActivity' ? ' active' : ''}`">动态</router-link>
                </div>
            </div>
        </div>


        <router-view :counts="counts" :nick="name" :thumb="thumb"></router-view>

    </section>
</template>

<script>
    export default {
        data: () => ({
            name: '',
            thumb: '',
            digest: '',
            views: 0,
            fans: 0,
            videos: [],
            counts: 0,
            is_follow: false,
            is_following: false,
        }),
        methods: {
            currentChange(page) {// 页码改变
                this.$router.push(`/dancers/${this.id}?page=${page}`);
            },
            load(route) {
                let api = this.api, {id, page} = route.query;
                page = +page || 1;

                api.get(`dancers/${id}`, {page}).then(e => {
                    this.name = e.name;
                    this.thumb = e.thumb;
                    this.digest = e.digest || '什么都没有留下';
                    this.views = e.views;
                    this.fans = e.fans;
                    this.videos = e.videos;// 再赋值
                    this.counts = e.counts;// 必须先改变数量 后改变页码 否则选中样式无法正常显示
                    this.page = page;
                    this.is_follow = e.is_follow;
                });
            },
            follow() {// 关注舞者
                if (this.is_following) return;
                if (!this.user_id) return this.sign.sign_box_show = true;

                this.is_following = true;
                this.api.post(`dancers/${this.id}/follow`).then(() => {
                    this.is_follow = true;
                    this.fans++;
                    this.is_following = false;
                }, e => {
                    this.alert.err(e.message);
                    this.is_following = false;
                });
            },
            unfollow() {// 取消关注
                if (this.is_following) return;

                if (!this.user_id) return this.sign.sign_box_show = true;

                this.confirm({
                    title: '取消关注',
                    content: `确认要取消关注该舞者吗?`,
                    sureCb: async () => {
                        this.is_following = true;
                        this.is_follow = false;
                        this.fans--;
                        await this.api.del(`dancers/${this.id}/follow`).catch(e => {
                            this.is_follow = true;
                            this.fans++;
                            this.is_following = false;
                            this.alert.err(e.message);
                        });
                        this.is_following = false;
                    }
                });
            }
        },

        computed: {
            id () {
                return this.$route.params.id;
            },
            user_id () {
                return this.$store.state.user.id;
            },
            sign() {
                return this.$store.state.sign;
            },
            query() {
                return this.$route.query;
            },
            page() {
                return this.query.page;
            },
            tab() {
                return this.$route.name
            }
        },
        watch: {
            /*'$route' (to) {
                this.load(to)
            },*/

            user_id() {
                this.api.get(`dancers/${this.id}/follow`).then(e => {
                    this.is_follow = !!e;
                }, () => {});
            }
        },
        /*beforeRouteUpdate(to, from, next) {
            this.api.get('user/collect/video', {page: to.query.page}).then(e => {
                this.videos = e;
                this.page = +to.query.page;
            });
            next();
        },*/
        beforeMount() {
            let {id, page} = this;
            page = +page || 1;

            this.api.get(`dancers/${id}`, {page}).then(e => {
                this.name = e.name;
                this.thumb = e.thumb;
                this.digest = e.digest || '什么都没有留下';
                this.views = e.views;
                this.fans = e.fans;
                this.counts = e.counts;// 必须先改变数量 后改变页码 否则选中样式无法正常显示
                this.is_follow = e.is_follow;
            });
        },
    }
</script>

<style scoped>
    @import "../../../static/css/views/dancer/detail.css";
</style>


// WEBPACK FOOTER //
// src/views/dancer/Detail.vue